export default {"src":"/_next/static/media/article-author.4f22e682.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};